export default "__VITE_PUBLIC_ASSET__98c27d78__"